import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import Reminders from '../../components/Reminders';
import {
  PERMISSION_REMINDERS,
  PERMISSION_REMINDERS_OWNED_BY_USER,
} from '../../Services/PermissionsService';
import { requirePermissions } from '../../router/RouteGuardsService';

// Optional: row action "confirm" deep-links back to the list with these params
const remindersSearchSchema = z.object({
  'confirm-id': z.coerce.number().optional().catch(undefined),
  'customer-id': z.coerce.number().optional().catch(undefined),
  vehicleId: z.coerce.number().optional().catch(undefined),
});

export const Route = createFileRoute('/_authenticated/reminders/')({
  validateSearch: remindersSearchSchema,
  beforeLoad: async ({ context }) => {
    await requirePermissions(
      [PERMISSION_REMINDERS, PERMISSION_REMINDERS_OWNED_BY_USER],
      ['read'],
      '/unauthorized',
      context
    );
    return {
      ...context,
      documentTitle: { main: 'tab.reminders', suffix: 'menu.reminders' },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RemindersRoute,
});

function RemindersRoute() {
  return <Reminders />;
}
